import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import { getSelectedDivision } from '@/helpers/utils/siteUtils';

export const getRecommendAlgoliaIndexName = (siteId: string, projectSettings: ProjectSettings): string => {
  const virtualAlgoliaConfig = projectSettings?.isVirtualAlgoliaEnabled
    ? JSON.parse(projectSettings.isVirtualAlgoliaEnabled)
    : {};
  const isVirtualAlgoliaEnabledSite = virtualAlgoliaConfig?.[`${getSelectedDivision()}Site`];

  if (isVirtualAlgoliaEnabledSite === true || isVirtualAlgoliaEnabledSite === 'true') {
    return `products_${siteId}_CSA`;
  }

  return `products_${siteId}`;
};
